const hidePreloader = () => {
  const preloader = document.getElementById("preloader");
  if (preloader) preloader.style.display = "none";
};

export default hidePreloader;
